const app = {
  state: {
    keepAlive: [],
    userInfo: {},
    version: '2.2'
  },
  mutations: {
    SET_KEEP_ALIVE: (state, keepAlive) => {
      state.keepAlive = keepAlive
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_PROVISION_HK: (state, index) => {
      state.provisionHKIndex = index
    }
  },
  actions: {
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js